// helpers.ts — Pure utility functions for SC form

/** Convert ISO date string to HTML date input value (YYYY-MM-DD) */
export const dateToInput = (v: string | null | undefined): string => {
  if (!v) return '';
  return v.substring(0, 10);
};

/** Convert HTML date input value to ISO date string */
export const inputToDate = (v: string): string | null => {
  if (!v) return null;
  return v + 'T00:00:00Z';
};

/** Split ISO date string into { year, month, day } strings */
export const dateToParts = (v: string | null | undefined): { year: string; month: string; day: string } => {
  if (!v) return { year: '', month: '', day: '' };
  const d = v.substring(0, 10); // YYYY-MM-DD
  const [y, m, dd] = d.split('-');
  return { year: y || '', month: m || '', day: dd || '' };
};

/** Join year/month/day strings into ISO date string, returns null if incomplete */
export const partsToDate = (year: string, month: string, day: string): string | null => {
  if (!year || !month || !day) return null;
  const y = year.padStart(4, '0');
  const m = month.padStart(2, '0');
  const d = day.padStart(2, '0');
  return `${y}-${m}-${d}T00:00:00Z`;
};

/** Format number with locale grouping, max 2 decimals */
export const fmt = (v: number | null | undefined): string => {
  if (v == null || v === 0) return '0';
  return v.toLocaleString('en-US', { maximumFractionDigits: 2 });
};

/** Format number as percentage with 1 decimal */
export const fmtPct = (v: number | null | undefined): string => {
  if (v == null) return '0.0';
  return v.toFixed(1);
};

/** Derive the status badge for a record */
export const getStatusBadge = (record: { fc110_71?: string; fc110_53?: string; fc110_51?: string; fc110_91?: string } | null): { text: string; cls: string } | null => {
  if (!record) return null;
  if (record.fc110_71 === 'Y') return { text: '已取消', cls: 'badge-warning' };
  if (record.fc110_53 === 'Y') return { text: '已結案', cls: 'badge-default' };
  if (record.fc110_51 === 'Y') return { text: '已核准', cls: 'badge-success' };
  if (record.fc110_91 === 'MODI') return { text: '修改', cls: 'badge-warning' };
  return null;
};

const ALWAYS_READONLY = new Set([
  'fc110_01', 'fc110_18', 'fc110_10', 'fc110_30',
  'fc110_32', 'fc110_33', 'fc110_34', 'fc110_35', 'fc110_36', 'fc110_37',
]);

/** Determine if a field should be disabled */
export const isFieldDisabledFn = (key: string, isEditing: boolean, mode: string): boolean => {
  if (!isEditing) return true;
  if (ALWAYS_READONLY.has(key)) return true;
  if (key === 'fc110_63' && mode === 'edit') return true;
  return false;
};
